<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

  <div class="modal-header">
    <h3 class="modal-title font">Modificar NIMAs del consentimiento</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" [formGroup]="formGroup">
    <div class="section-header">
      <h4 class="table-title">NIMAs incluidos en el consentimiento</h4>
      <button type="button" class="btn btn-danger" (click)="removeOrDeactivateSelected()">
        {{ canDelete() ? 'Borrar' : 'Dar de baja' }}
      </button>
    </div>
    <div *ngIf="poseedoresConsentimiento.length; else emptyIncluded" class="table-wrapper">
      <lib-ge-table
        [headArray]="includedHeadArray"
        [gridArray]="poseedoresConsentimiento"
        (checked)="onIncludedChecked($event)">
      </lib-ge-table>
    </div>
    <ng-template #emptyIncluded>
      <div class="empty-message">Sin poseedores asociados al consentimiento</div>
    </ng-template>

    <div class="section-header mt-3">
      <h4 class="table-title">Poseedores del mismo CIF no incluidos</h4>
      <button type="button" class="btn btn-primary" (click)="addNimas()">Añadir</button>
    </div>
    <div *ngIf="poseedoresMismoDocumentoNoIncluidos.length; else emptyAvailable" class="table-wrapper">
      <lib-ge-table
        [headArray]="availableHeadArray"
        [gridArray]="poseedoresMismoDocumentoNoIncluidos"
        (checked)="onAvailableChecked($event)">
      </lib-ge-table>
    </div>
    <ng-template #emptyAvailable>
      <div class="empty-message">No hay poseedores adicionales para el mismo CIF</div>
    </ng-template>
  </div>

  <div class="modal-footer actions">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="cerrar()">Volver</button>
    </div>
  </div>
</div>
